module.exports = __webpack_public_path__ + "王峰-8eddeec5.png";